/* React */
import React, { useState } from "react";

/* Ionic */
import {
  chevronBack,
  chevronForward,
} from "ionicons/icons";

/* Swiper */
import {
  Swiper,
  SwiperClass,
  SwiperSlide,
} from "swiper/react";
import "swiper/css";

/* Components */
import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";
import SegmentButton from "src/components/shared/buttons/segment-button/SegmentButton";

/* Stylesheet */
import styles from "./ConceptSelect.module.scss";

/* Interfaces */
import {
  BasicProps,
  Keys,
} from "src/shared/interfaces/custom-cohorts/CustomCohorts";

interface ConceptSelectProps {
  options: string[];
  values: string[];
  disabled: boolean;
  handleUpdate: <K extends keyof BasicProps>(
    key: K,
    data?: {
      values: BasicProps[K];
    },
  ) => void;
}

const SLIDES_PER_VIEW: number = 2;

const ConceptSelect: React.FC<ConceptSelectProps> = ({
  options,
  values,
  disabled,
  handleUpdate,
}) => {
  const showNav = options.length > SLIDES_PER_VIEW;

  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [swiperInstance, setSwiperInstance] =
    useState<SwiperClass | null>(null);

  const handleValues = (option: string) => {
    const updatedValues: string[] = values.includes(option)
      ? values.filter((val) => val !== option)
      : [...values, option];

    handleUpdate(Keys.VALUES, { values: updatedValues });
  };

  return (
    <div className={styles.concept_select}>
      {showNav ? (
        <PrimaryFabButton
          scssProps={{
            color: disabled
              ? "var(--ion-color-disabled)"
              : "var(--ion-color-text-tertiary)",
            background: "transparent",
          }}
          className={"small"}
          icon={chevronBack}
          ariaLabel={"Previous"}
          disabled={disabled || activeIndex === 0}
          onClick={() => swiperInstance?.slidePrev()}
        />
      ) : undefined}
      <div
        style={{
          width: showNav ? "calc(100% - 104px)" : "100%",
        }}
        className={styles.swiper_container}
      >
        <Swiper
          slidesPerView={SLIDES_PER_VIEW}
          onSwiper={setSwiperInstance}
          // enabled={disabled}
          onSlideChange={(swiper) =>
            setActiveIndex(swiper.activeIndex)
          }
        >
          {options.map((option: string, index: number) => {
            return (
              <SwiperSlide
                className={styles.slide}
                key={index}
              >
                <SegmentButton
                  label={option}
                  value={values?.includes(option)}
                  disabled={disabled}
                  onClick={() => handleValues(option)}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      {showNav ? (
        <PrimaryFabButton
          scssProps={{
            color: disabled
              ? "var(--ion-color-disabled)"
              : "var(--ion-color-text-tertiary)",
            background: "transparent",
          }}
          className={"small"}
          icon={chevronForward}
          ariaLabel={"Next"}
          disabled={
            disabled ||
            activeIndex === options.length - SLIDES_PER_VIEW
          }
          onClick={() => swiperInstance?.slideNext()}
        />
      ) : undefined}
    </div>
  );
};

export default ConceptSelect;
